import { createRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { getCurrentUser } from '@/integrations/idb/models/users';
import { rootRoute } from '@/root-route';
import * as dashboard from '@/shared/dashboard';
import { AUTH_ROUTES } from './consts/routes';

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: AUTH_ROUTES.login,
  validateSearch: zodValidator(
    z.object({
      redirect: z
        .string()
        .refine((val) => val.startsWith('/'), 'Must start with /')
        .refine((val) => !val.startsWith('//'), 'Cannot start with //')
        .refine((val) => !val.includes('://'), 'Cannot contain ://')
        .refine(
          (val) => !/[<>"'`]/.test(val),
          'Cannot contain special characters',
        )
        .optional()
        .catch(undefined),
    }),
  ),
  beforeLoad: async ({ search }) => {
    const currentUser = await getCurrentUser();

    if (currentUser?.token) {
      throw redirect({
        to: search.redirect || dashboard.DASHBOARD_ROUTES.index,
        ignoreBlocker: true,
        replace: true,
      });
    }
  },
}).lazy(() => import('./login').then(({ Route }) => Route));

export const unauthorizedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: AUTH_ROUTES.unauthorized,
}).lazy(() => import('./unauthorized').then(({ Route }) => Route));

export const resetPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: AUTH_ROUTES.resetPassword,
  validateSearch: zodValidator(
    z.object({
      token: z.string().optional().catch(undefined),
    }),
  ),
  beforeLoad: ({ search }) => {
    if (!search.token) {
      throw redirect({ to: AUTH_ROUTES.login, replace: true });
    }
  },
}).lazy(() => import('./reset-password').then(({ Route }) => Route));
